import { useMutation } from '@tanstack/react-query';

import { DAY_OF_WEEK } from 'src/features/membershipType/types';
import { Membership } from 'src/features/membership/types';
import axios from 'src/lib/axios';
import { MutationConfig } from 'src/lib/react-query';
import { GeneralSmartParkError } from 'src/registry/types/axios';
import { formatResourcePath } from 'src/utils/regex';

const RESOURCE = `sp-core/:parkingId/memberships/membership/:membershipId/`;

type MutationFnType = typeof mutationFn;

interface DTO {
    parkingId: string;
    membershipId: string;
    is_active?: boolean;
    membership_allowed_times?: {
        day_of_week: DAY_OF_WEEK;
        from_time: string;
        to_time: string;
    }[];
}
const mutationFn = ({ parkingId, membershipId, ...data }: DTO): Promise<Membership> => {
    return axios.patch(formatResourcePath(RESOURCE, { parkingId, membershipId }), data);
};

const useMutationHook = (options: MutationConfig<MutationFnType, GeneralSmartParkError> = {}) =>
    useMutation({
        mutationFn,
        ...options,
    });

export { useMutationHook as usePartialUpdateMembership };
